<template>
  <div class="member-datatable" data-test="member-datatable">
      <CustomTable :rowPerPage="rowPerPageValue" @update:rowPerPage="rowPerPageValue = $event" @update:clickPage="currentClickPage" :loadingStatus="loadingStatus" :offset="startValue" :totalItem="tableData.length">
        <template #tablehead>
            <th v-for="field in tableHead" :key="field" :style="{width: field.width}">{{field.name}}</th>
        </template>
        <template #tablebody v-if="tableData.length > 0">
            <tr v-for="(table,idx) in tableData" :key="idx">
                <td>{{table.username}}</td>
                <td>{{table.attributes?.positionName?.length > 0 ? table.attributes?.positionName?.[0] : '-'}}</td>
                <td>{{table.attributes?.agcName?.length > 0 ? table.attributes?.agcName?.[0] : '-'}}</td>
                <td>{{table.attributes?.orgName?.length > 0 ? table.attributes?.orgName?.[0] : '-'}}</td>
                <td>{{table.attributes?.provinceName?.length > 0 ? table.attributes?.provinceName?.[0] : '-'}}</td>
                <td>
                    <div class="flex lg:justify-center items-center">
                        <a class="t-tooltip w-8 h-8 p-[5px] inline-flex justify-center hover:bg-[#22418147]" @click="emit('setPassword',table)">
                            <KeyIcon class="w-full h-full"/>
                            <span class="t-tooltip-text">สร้างรหัสผ่านใหม่</span>
                        </a>
                        <a class="t-tooltip w-8 h-8 p-[6px] inline-flex justify-center hover:text-theme-1 ml-3 hover:bg-[#22418147]" @click="emit('viewState',table)">
                            <EyeIcon class="w-full h-full"/>
                            <span class="t-tooltip-text">แสดง</span>
                        </a>
                        <router-link :to="{name: 'user-hcm-management'}" @click.prevent="filterHandle(table.username)" class="t-tooltip w-8 h-8 p-[6px] inline-flex justify-center hover:text-theme-1 ml-3 hover:bg-[#22418147]" v-if="table.attributes?.roleCode?.[0] == 'hcm'">
                            <UsersIcon class="w-full h-full"/>
                            <span class="t-tooltip-text">จัดการ CM</span>
                        </router-link>
                    </div>
                </td>
            </tr>
        </template>
        <template #tablebody v-else>
            <tr>
                <td class="text-center" :colspan="tableHead.length">ไม่มีข้อมูล</td>
            </tr>
        </template>
      </CustomTable>
  </div>
</template>

<script setup>
import CustomTable from "./CustomTable.vue"
import { reactive,ref,onMounted, watch, computed } from "vue"
import Swal from "sweetalert2"
import axios from "axios"
import { useStore } from "vuex"

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})

const props = defineProps({
    filter: Object
})
const emit = defineEmits(["setPassword","viewState"])

const store = useStore()
const startValue = ref("0")
const rowPerPageValue = ref("10")
const tableData = ref([])
const loadingStatus = ref(false)
const tableHead = reactive([
    {name: "ชื่อผู้ใช้งาน", width: "15%"},
    {name: "ตำแหน่ง", width: "20%"},
    {name: "หน่วยงาน", width: "20%"},
    {name: "หน่วยงานย่อย", width: "20%"},
    {name: "จังหวัด", width: "15%"},
    {name: "การดำเนินการ", width: "10%"}
])
let currPage = 1, currState
watch(()=> rowPerPageValue.value, (val)=>{
    startValue.value = ((currPage - 1) * rowPerPageValue.value).toString()
    currState = "selectPerPage"
    fetchUserData()
})
watch(()=>props.filter, ()=>{
    startValue.value = "0"
    currPage = 1
    fetchUserData()
})

const paramsComputed = computed(()=>{
    let result = {
        "start": startValue.value,
        "length": rowPerPageValue.value
    }
    let qFilter = ""
    if(props.filter.username)
        result =  {...result, username: props.filter.username}
    if(props.filter.user_group)
        result = {...result, q: qFilter+=` roleCode:${props.filter.user_group}`}
    if(props.filter.province)
        result = {...result, q: qFilter+=` provinceCode:${props.filter.province}`}
    if(props.filter.organize)
        result = {...result, q: qFilter+=` agcCode:${props.filter.organize}`}
    if(props.filter.sub_organize)
        result = {...result, q: qFilter+=` orgCode:${props.filter.sub_organize}`}

    return result
})
const currentClickPage = (evt) =>{
    currState = evt
    if(evt === "Next")
        currPage += 1
    else if(evt == "Prev")
        currPage -= 1
    else
        currPage = 1
    startValue.value = ((currPage - 1) * rowPerPageValue.value).toString()
    fetchUserData()
}
const fetchUserData = async () =>{
    const token = store.getters["userAuth/getToken"];
    loadingStatus.value = !loadingStatus.value
    const res = await axios.get(
            `${process.env.VUE_APP_BASE_API}kcadmin/users`,
            {
                headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                params: paramsComputed.value
            }
        )
        .catch(()=>{
            startValue.value = "0"
            swalCustom.fire({
                text: "ระบบผิดพลาด",
                icon: "warning",
                // timer: 3000, //timeOut for auto-close
                confirmButtonText: "ปิด",
            })
        })
    if(res.status == 200){
        loadingStatus.value = !loadingStatus.value
        tableData.value = res.data.data
        if(tableData.value.length == 0){
            //when search and not found or change per page except click next page
            if(currState != "Next"){
                currPage = 1
                startValue.value = "0"
                //when startValue not match with any record, fetch again with start 0 and curr per page selected
                if(currState == "selectPerPage")
                    fetchUserData()
            }
        }
    }
}

const filterHandle  = (val) =>{
    store.dispatch("hcmUserFilter/setHcm",val);
}
onMounted(()=>{
    fetchUserData()
})
</script>

<style lang="scss">

</style>